import {
  AccessDenied,
  FeatureToggleList as FeatureToggleListComponent,
} from '@verifime/components';
import { useEffect, useState } from 'react';

import { api } from '@verifime/api-definition';
import { getFeatureToggleConfigWithResolvedValue, TApp } from '@verifime/utils';

export const FeatureToggleList = ({ app }: Readonly<{ app: TApp }>) => {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    api
      .getV1userme()
      .then((user) => {
        setIsAdmin(user.roles?.includes('admin'));
      })
      .catch((error) => {
        console.error('Failed to fetch user info:', error);
        setIsAdmin(false);
      });
  }, []);

  const toggles = getFeatureToggleConfigWithResolvedValue(app);

  if (!isAdmin) {
    return <AccessDenied />;
  }

  return <FeatureToggleListComponent togglesWithConfig={toggles} />;
};
